import {
  ISiteOption,
  ISiteOptionMobileApp,
  ISiteOptionSession,
} from '~/assets/interfaces/site'

// Значения опций сайта, пока бэк их не прислал. Единственное место с
// дефолтами: геттеры getOptions* в store/site.ts генерируются из этих ключей.

// true — чтобы до появления полей на бэке приложение вело себя как раньше.
export const DEFAULT_MOBILE_APP_OPTIONS: ISiteOptionMobileApp = {
  barcodeScanner: true,
}

export const DEFAULT_SITE_OPTIONS: ISiteOption = {
  currency: '₽',
  currencyCode: 'RUB',
  phoneMask: '(+7|8) 999 999 99 99',
  copyright: true,
  canChangeQuantity: false,
  authType: 'sms',
  isOnlyUserToAccessOrder: false,
  catalogPageType: 'type-1',
  isRunSliderImmediately: false,
  productShadow: false,
  productInStockViewType: 'type-1',
  // true — чтобы до появления поля на бэке сравнение работало как раньше.
  compare: true,
  // Новая функция: выключена, пока бэк явно не включит.
  quickView: false,
  // Оформление по желанию: без поля с бэка карточки выглядят как раньше.
  productImageBackdrop: false,
  mobileApp: { ...DEFAULT_MOBILE_APP_OPTIONS },
}

export const DEFAULT_OPTIONS_SESSION: ISiteOptionSession = {
  isShowComponentLocationQuestion: false,
}
